const modalActionTypes = {
  TOGGLE_CONTACT_MODAL: "TOGGLE_CONTACT_MODAL",
};

export default modalActionTypes;
